module.exports = __webpack_public_path__ + "img/B_ezplan2.0a377ecc.png";